import axios from '../services/axios';
import url from '../services/url';

export const checkPermission = async (role, entityType, permission) => {
  try {
    const response = await axios.post(url('permify/check'), {
      role,
      entityType,
      permission
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('user.token')}`,
      },
    });

    return response.data.allowed;
  } catch (error) {
    console.warn('⚠️ Permify service unavailable, defaulting to allow access:', error?.message);
    return true;
  }
};

export const checkBulkPermissions = async (role, checks) => {
  try {
    const response = await axios.post(url('permify/bulk-check'), {
      role,
      checks
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('user.token')}`,
      },
    });

    return response.data.results;
  } catch (error) {
    console.warn('⚠️ Permify service unavailable, defaulting to allow all permissions:', error?.message);
    // Return all permissions as allowed when Permify is down
    return checks.map(check => ({
      entityType: check.entityType,
      permission: check.permission,
      allowed: true,
    }));
  }
};

